// What keeps a draft from being saved or exported, in words, before the server would refuse it:
// every title has text, and the video is at most 5 minutes (the reducer keeps every other bound).
import { formatClock } from "./time";
import { MAX_TOTAL_MS, totalMs, type Timeline } from "./timeline";

/** The draft's problems, in the order to fix them; empty when it can be saved. */
export function problems(timeline: Timeline): string[] {
  const found: string[] = [];
  const total = totalMs(timeline);
  if (total > MAX_TOTAL_MS) {
    const most = formatClock(MAX_TOTAL_MS);
    found.push(`The video runs ${formatClock(total)}; the most is ${most}. Trim or remove a clip.`);
  }
  if (timeline.clips.some((clip) => clip.kind === "text" && clip.text.trim() === "")) {
    found.push("Every title needs text.");
  }
  return found;
}
